import { supabase } from "@/integrations/supabase/client";

export async function getActiveTemplates(occasion?: string) {
  let query = supabase
    .from("card_templates")
    .select("*")
    .eq("is_active", true)
    .is("deleted_at", null)
    .order("name");

  if (occasion) {
    // An empty-string occasion marks a template as a wildcard — it
    // should show up under every occasion filter. Include those rows
    // alongside exact matches.
    query = query.in("occasion", [occasion, ""]);
  }

  const { data, error } = await query;
  return { data: data || [], error };
}

export async function getActiveTemplateColumns(occasion?: string) {
  let query = supabase
    .from("card_templates")
    .select("id, name, image_url, occasion, price")
    .eq("is_active", true)
    .is("deleted_at", null);

  if (occasion) {
    // An empty-string occasion marks a template as a wildcard — it
    // should show up under every occasion filter. Include those rows
    // alongside exact matches.
    query = query.in("occasion", [occasion, ""]);
  }

  const { data, error } = await query;
  return { data: data || [], error };
}

export async function getTemplateImageUrl(templateId: string) {
  const { data, error } = await supabase
    .from("card_templates")
    .select("image_url, back_text, back_text_style, music_url, music_autoplay, floating_emojis_enabled")
    .eq("id", templateId)
    .maybeSingle();
  return { data, error };
}

/**
 * Lightweight helper that returns just the IDs of active templates
 * that have an editable `polotno_json`. Used by StepDesign to stamp
 * a "Editable" badge on the corresponding thumbnails without having
 * to ship the full JSON payload for every template in the list.
 */
export async function getEditableTemplateIdSet(): Promise<Set<string>> {
  const { data } = await supabase
    .from("card_templates")
    .select("id")
    .eq("is_active", true)
    .is("deleted_at", null)
    .not("polotno_json", "is", null);
  return new Set((data || []).map((t) => t.id));
}
